import template from './ticketConveyancing.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    conveyancing: '<',
    countries: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      TicketLoanSecuritySplit,
      TicketLoanFee,
      TransactionType,
      OwnershipType,
      PropertyType,
      helperService
    ) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.contacts = [];
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.organizationVat = 0;
      ctrl.availableConveyancingFeeTypes = [];
      ctrl.availablePropertyTypes = [];
      ctrl.availableOwnershipTypes = [];
      ctrl.availableTransactionTypes = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.organizationVat = helperService.getOrganizationVat();
        ctrl.availableConveyancingFeeTypes = helperService.getAvailableConveyancingFeeTypes();
        ctrl.availablePropertyTypes = PropertyType.available();
        ctrl.availableOwnershipTypes = OwnershipType.available();
        ctrl.availableTransactionTypes = TransactionType.available();
        ctrl.conveyancing = ctrl.conveyancing || {};
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.ticketConveyancingSplitAdd = ($event) => {
        $event.stopPropagation();
        ctrl.conveyancing.dealConveyancingSecuritySplit.push(TicketLoanSecuritySplit.blank());
      };

      ctrl.ticketConveyancingSplitDelete = (index) => {
        ctrl.conveyancing.dealConveyancingSecuritySplit.splice(index, 1);
        ctrl.saveTicketConveyancing();
      };

      ctrl.ticketConveyancingFeeAdd = ($event, feeType) => {
        $event.stopPropagation();
        ctrl.conveyancing.fees.push(TicketLoanFee.blank(feeType));
      };

      ctrl.ticketConveyancingFeeDelete = (index) => {
        ctrl.conveyancing.fees.splice(index, 1);
        ctrl.saveTicketConveyancing();
      };

      ctrl.toggleGstVat = (feeToEdit) => {
        const fee = feeToEdit;
        if (fee.isGstVatApplicable) {
          fee.amount += fee.amount * ctrl.organizationVat.decimal;
        } else {
          fee.amount /= ctrl.organizationVat.decimal + 1;
        }
        ctrl.saveTicketConveyancing();
      };

      /*
       * Save ticket conveyancing
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketConveyancing = () => ctrl.onFinished({ conveyancing: ctrl.conveyancing });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
